import MD5 from "../Lib/jsb_runtime_md5"
import UIManager from "../Shared/UIManager"
import Constant from "../Shared/Constant"
import Utils from "../Shared/Utils"
import AddressManager from "../Shared/AddressManager"

const {ccclass, property} = cc._decorator
const CheckUpdateTimeOut = 10

@ccclass
export default class HotUpdate extends cc.Component {
    @property({type: cc.Asset})
    manifestUrl: cc.Asset = null

    @property(cc.Node)
    nodeUpdateUI: cc.Node = null

    @property(cc.Node)
    nodeCheck: cc.Node = null

    @property(cc.Label)
    lbFileProgress: cc.Label = null

    @property(cc.Label)
    lbFileSize: cc.Label = null

    @property(cc.Label)
    lbByteProgress: cc.Label = null

    @property(cc.ProgressBar)
    barFileProgress: cc.ProgressBar = null

    @property(cc.ProgressBar)
    barByteProgress: cc.ProgressBar = null

    private _checkingOrUpdating = false
    private _canRetry = false
    private _storagePath = ''
    private _am = null
    private _verfiyFailed = false
    private _checkUpdateTime = -1
    private _checkNetworkTimes = 0
    private _networkAvailable = false
    private _retryTime = 0

    onLoad () {
        this.barFileProgress.progress = 0
        this.barByteProgress.progress = 0
        this.nodeUpdateUI.active = false
        cc.sys.isMobile && this.initHotUpdate()
    }

    start () {
        cc.log("=====进入热更页面");
        if (!cc.sys.isMobile) {
            this.enterGame()
        }else {
            this.checkNetworkAvailable()
        }
    }

    update (dt) {
        // 默认的超时时间太长，这里让超时短一点
        if (this._checkUpdateTime !== -1) {
            if (this._checkUpdateTime > CheckUpdateTimeOut) {
                cc.log("HotUpdate: 检查更新超时")
                this._checkUpdateTime = -1
                this._am.setEventCallback(null)
                this._checkingOrUpdating = false

                UIManager.showTipUI("检查更新超时，请确认您的网络是否正常！", function () {
                    this.scheduleOnce(function () {
                        this.checkUpdate()
                    }, 0.1)
                }.bind(this), "重试")
            }else {
                this._checkUpdateTime += dt
            }
        }
    }

    onBtnClick (event, userData) {
        if (userData === "kefu") {
            Utils.openOnlineCustomerUrl()
        }
    }

    checkCb (event) {
        this._checkUpdateTime = -1
        let needHotUpdate = false

        cc.log('HotUpdate: Code: ' + event.getEventCode())
        switch (event.getEventCode())
        {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
                cc.log("HotUpdate: 没有找到本地的version.manifest文件，跳过更新")
                break
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                cc.log("HotUpdate: 下载version.manifest文件失败，跳过更新")
                break
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                cc.log("HotUpdate: 已经是最新版本，进入游戏大厅")
                break
            case jsb.EventAssetsManager.NEW_VERSION_FOUND:
                cc.log('HotUpdate: 发现新版本，开始下载')
                this.barFileProgress.progress = 0
                this.barByteProgress.progress = 0
                needHotUpdate = true
                break
            default:
                return
        }

        this._am.setEventCallback(null)
        this._checkingOrUpdating = false

        if (needHotUpdate) {
            this.hotUpdate()
        }else {
            cc.sys.localStorage.setItem("CurrentVersion", this._am.getLocalManifest().getVersion())
            this.enterGame()
        }
    }

    updateCb (event) {
        var needRestart = false
        var failed = false
        
        switch (event.getEventCode())
        {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
                cc.log('HotUpdate: 没有找到本地的project.manifest文件')
                failed = true
                break
            case jsb.EventAssetsManager.UPDATE_PROGRESSION:
                let percent = event.getPercent() || 0
                let percentFile = event.getPercentByFile() || 0
                this.barByteProgress.progress = percent
                this.barFileProgress.progress = percentFile
                this.lbFileProgress.string = "正在为您下载更新资源包 " + (Math.round(percentFile * 100)).toString() + '%'
                this.lbByteProgress.string = "正在为您下载更新资源包 " + (Math.round(percent * 100)).toString() + '%'
                this.lbFileSize.string = `(${(this._am.getDownloadedBytes() / 1024 / 1024).toFixed(2)}M/${(this._am.getTotalBytes() / 1024 / 1024).toFixed(2)}M)`
                this._retryTime > 0 && (this._retryTime = 0)

                var msg = event.getMessage()
                if (msg) {
                    cc.log('HotUpdate: Updated file: ' + msg)
                    // cc.log(percent/100 + '% : ' + msg)
                }
                break
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                cc.log('HotUpdate: 下载project.manifest失败')
                failed = true
                break
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                cc.log('HotUpdate: 已经是最新版本')
                failed = true
                break
            case jsb.EventAssetsManager.UPDATE_FINISHED:
                cc.log('HotUpdate: 更新完成：' + event.getMessage())
                needRestart = true
                break
            case jsb.EventAssetsManager.UPDATE_FAILED:
                cc.log('HotUpdate: 更新失败：' + event.getMessage())
                this._checkingOrUpdating = false
                this._canRetry = true

                // 验证出问题（md5不匹配，可能是更新过程中，又有了新的版本造成的）
                if (this._verfiyFailed) {
                    this.restart()
                }else {
                    if (this._retryTime === 0) {
                        this._retryTime = new Date().getTime()
                        this.retry()
                    }else {
                        if (new Date().getTime() - this._retryTime > 10000) {
                            // 弹窗提示重新下载
                            UIManager.showTipUI("网络开小差，请确认您的网络是否正常", function () {
                                this._retryTime = new Date().getTime()
                                this.retry()
                            }.bind(this), "重试")
                        }else {
                            this.retry()
                        }
                    }
                }
                break
            case jsb.EventAssetsManager.ERROR_UPDATING:
                cc.log('HotUpdate: 更新文件出错： ' + event.getAssetId() + ', ' + event.getMessage())
                break
            case jsb.EventAssetsManager.ERROR_DECOMPRESS:
                cc.log(event.getMessage())
                break
            default:
                break
        }

        if (failed) {
            this._am.setEventCallback(null)
            this._checkingOrUpdating = false
        }

        if (needRestart) {
            this._am.setEventCallback(null)
            // Prepend the manifest's search path
            var oldPaths = jsb.fileUtils.getSearchPaths()
            var newPaths = this._am.getLocalManifest().getSearchPaths()
            console.log(JSON.stringify(newPaths))
            Array.prototype.unshift.apply(oldPaths, newPaths)

            // 去除重复路径。某些情况下导致搜索路径有重复项，从而引起没办法读取到安装包里面的配置。
            let searchPaths = []
            oldPaths.forEach(item => {
                if (searchPaths.indexOf(item) === -1) {
                    searchPaths.push(item)
                }
            })

            // This value will be retrieved and appended to the default search path during game startup,
            // please refer to samples/js-tests/main.js for detailed usage.
            // !!! Re-add the search paths in main.js is very important, otherwise, new scripts won't take effect.
            cc.sys.localStorage.setItem('HotUpdateSearchPaths', JSON.stringify(searchPaths))
            jsb.fileUtils.setSearchPaths(searchPaths)
            cc.sys.localStorage.setItem("HotUpdateFinished", 1) 
            cc.sys.localStorage.setItem("CurrentVersion", this._am.getLocalManifest().getVersion())
            cc.log("searchPaths:="+JSON.stringify(searchPaths))
            this.restart()
        }
    }

    private initHotUpdate() {        
        this._storagePath = Constant.HotUpdateStoragePath
        cc.log('HotUpdate: Storage path for remote asset : ' + this._storagePath)

        // Init with empty manifest url for testing custom manifest
        this._am = new jsb.AssetsManager('', this._storagePath, Utils.versionCompare)
        this._am.setVerifyCallback(this.verifyCallback.bind(this))

        // if (cc.sys.os === cc.sys.OS_ANDROID) {
        //     // Some Android device may slow down the download process when concurrent tasks is too much.
        //     // The value may not be accurate, please do more test and find what's most suitable for your game.
        //     this._am.setMaxConcurrentTask(2)
        //     cc.log("HotUpdate: Max concurrent tasks count have been limited to 2")
        // }
    }

    private enterGame () {
        if (cc.director["_getSceneUuid"]("Hall")) {
            cc.director.loadScene("Hall")
        }else {
            UIManager.showTipUI("没有获取到资源更新，请稍后重试", function () {
                cc.game.restart()
            }.bind(this), "重试")
        }
    }

    private checkNetworkAvailable () {
        this.schedule(this.checkNetwork, 0.5)
    }

    // 解决国行苹果手机首次安装，弹出网络权限选择，导致获取数据失败的问题
    // 有网才检查更新
    private checkNetwork () {
        this._checkNetworkTimes++

        if (this._checkNetworkTimes > 20) {
            this._checkNetworkTimes = 0
            this.unschedule(this.checkNetwork)

            UIManager.showTipUI("网络已断开，请检查您的网络连接是否正常", function () {
                this.checkNetworkAvailable()
            }.bind(this), "重试")
        }else {
            let xhr = new XMLHttpRequest()
            xhr.responseType = 'json'
        
            xhr.onload = async function () {
                if (!this._networkAvailable && this._checkNetworkTimes > 0) {
                    cc.log("HotUpdate: Network is available, start checking for update")
                    this._networkAvailable = true
                    this.unschedule(this.checkNetwork)
                    // 设置热更域名
                    let domain = await this.getHotUpdateDomain()
                    cc.log("HotUpdateDomainRETURN ::="+JSON.stringify(domain))
                    let isDomainConnected = domain ? await this.checkDomainConnect(domain) : false
                    if (isDomainConnected) {
                        this._am.setHostUrl(domain)
                        cc.log("HotUpdate: 新的热更域名是：", domain)
                    }
                    this.checkUpdate()
                }
            }.bind(this)

            let url = this._checkNetworkTimes < 10 && "http://www.baidu.com" || "http://www.google.com"
            xhr.open("GET", url, true)
            xhr.send()
        }
    }

    private getHotUpdateDomain () : Promise<string> {
        return new Promise(resolve => {
            let domain = ""

            AddressManager.serverAddressArr.forEach(address => {
                let xhr = new XMLHttpRequest()
                xhr.responseType = 'json'
            
                xhr.onload = function () {
                    cc.log("HotUpdateDomainQuest:=" +JSON.stringify( xhr.response.data))
                    if (xhr.status === 200){
                        domain = xhr.response.data.value0 || ""
                    }
                    resolve(domain)
                }.bind(this)
                let url = address + "/imsbase/api/conf/getValue?type=hotUpdate"
                cc.log("HotUpdateURL:=" + url)
                xhr.open("GET", url, true)
                xhr.send()
            });

            // 5秒没有回调则使用默认地址
            this.scheduleOnce(function () {
                resolve(domain)
            }, 5)
        })
    }

    private checkDomainConnect (domain) : Promise<boolean> {
        return new Promise(resolve => {
            let xhr = new XMLHttpRequest()
        
            xhr.onload = function () {
                if (xhr.status === 200){
                    resolve(true)
                }else {
                    resolve(false)
                }
            }.bind(this)

            xhr.onerror = function () {
                resolve(false)
            }

            xhr.open("GET", domain, true)
            xhr.send()

            // 5秒没有回调false
            this.scheduleOnce(function () {
                resolve(false)
            }, 5)
        })
    }
    
    private checkUpdate () {
        if (this._checkingOrUpdating) {
            cc.log('HotUpdate: Checking or updating ...')
            return
        }
        if (this._am.getState() === jsb.AssetsManager.State.UNINITED) {
            // Resolve md5 url
            var url = this.manifestUrl.nativeUrl
            if (cc.loader.md5Pipe) {
                url = cc.loader.md5Pipe.transformURL(url)
            }
            this._am.loadLocalManifest(url)
        }
        if (!this._am.getLocalManifest() || !this._am.getLocalManifest().isLoaded()) {
            cc.log('HotUpdate: Failed to load local manifest ...')
            return
        }
        this._am.setEventCallback(this.checkCb.bind(this))
        // 必须在this._am.checkUpdate()之前执行，因为有可能执行this._am.checkUpdate()的时候会立即进入checkCb回调（下载完成）
        this._checkUpdateTime = 0
        this._am.checkUpdate()
        this._checkingOrUpdating = true
    }

    private hotUpdate () {
        if (this._am && !this._checkingOrUpdating) {
            this._am.setEventCallback(this.updateCb.bind(this))

            if (this._am.getState() === jsb.AssetsManager.State.UNINITED) {
                // Resolve md5 url
                var url = this.manifestUrl.nativeUrl
                if (cc.loader.md5Pipe) {
                    url = cc.loader.md5Pipe.transformURL(url)
                }
                this._am.loadLocalManifest(url)
            }

            this._am.update()
            this._checkingOrUpdating = true
            this.nodeUpdateUI.active = true
            this.nodeCheck.active = false
        }
    }

    private restart () {
        cc.audioEngine.stopAll()
        cc.game.restart()
    }
    
    private retry () {
        if (!this._checkingOrUpdating && this._canRetry) {
            this._canRetry = false            
            cc.log('HotUpdate: Retry failed Assets...')
            this._am.downloadFailedAssets()
        }
    }

    // Setup the verification callback, but we don't have md5 check function yet, so only print some message
    // Return true if the verification passed, otherwise return false
    private verifyCallback(path, asset) {
        // When asset is compressed, we don't need to check its md5, because zip file have been deleted.
        var compressed = asset.compressed
        // Retrieve the correct md5 value.
        var expectedMD5 = asset.md5
        // asset.path is relative path and path is absolute.
        var relativePath = asset.path
        // The size of asset file, but this value could be absent.
        var size = asset.size
        if (compressed) {
            cc.log("HotUpdate: Verification passed : " + relativePath)
            return true
        }
        else {
            // 调用getDataFromFile方法会使得内存升高。如果遇到大文件，很可能内存飙升，从而在一些低端机上崩溃。
            const md5str = MD5(jsb.fileUtils.getDataFromFile(path))

            if (md5str === expectedMD5) {
                cc.log("HotUpdate: Verification passed : " + relativePath + ' (' + expectedMD5 + ')')
                return true
            }else {
                cc.log("HotUpdate: Verification failed : " + relativePath + ' (' + expectedMD5 + ')')
                this._verfiyFailed = true
                return false
            }
        }
    }
}
